import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import {
  Loader,
  NothingFoundAlert,
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { ROUTES } from 'config';
import { useRouteMatch } from 'react-router-dom';
import { useRouteParams } from 'utils/useIdParam';
import { useAdminAdmin } from 'store/admin-admins';
import { AdminAdminsActions } from 'containers/admin/admins/atoms';

export const AdminAdminLayout: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const { id: adminId } = useRouteParams(ROUTES.admin.admins.details);

  const { data: admin, isLoading } = useAdminAdmin(adminId);

  if (adminId && isLoading) return <Loader />;
  if (adminId && !admin) return <NothingFoundAlert />;

  return (
    <Stack gap={2}>
      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('sidebar.administrators'),
            url: ROUTES.admin.admins.list,
          },
          {
            label: !adminId
              ? t('administrators.add_administrator')
              : admin
              ? admin.fullName
              : '',
          },
        ]}
        side={
          admin ? (
            <AdminAdminsActions id={admin.id} name={admin.fullName} />
          ) : null
        }
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'details',
                label: t('common.settings'),
                url: ROUTES.admin.admins.details.replace(':id', adminId),
                isActive:
                  path === ROUTES.admin.admins.details ||
                  path === ROUTES.admin.admins.create,
                disabled: !admin,
              },
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
